import { AnalyticsServiceFactory } from 'services';
import { BaseIntegrationProps } from './BaseIntegrationProps';
import { ApricotIntegrationProps } from './Product/Apricot/ApricotIntegrationProps';
import { EtoIntegrationProps } from './Product/ETO/ETOIntegrationProps';
import { NoneIntegrationProps } from './Product/None/NoneIntegrationProps';
import { DEFAULT_OVERRIDE_TENANT_ID, IntegrationUtils } from './integrationUtils';
import { IntegrationType } from './IntegrationType';



IntegrationUtils.init(process.env);
const root = document.getElementById('root') || document.body;
export let integrationProps: BaseIntegrationProps;
export const integrationType = (root && root.getAttribute('data-integration-type')) || IntegrationType.NONE;

switch (integrationType) {
    case IntegrationType.Apricot:
        integrationProps = new ApricotIntegrationProps(root);
        break;
    case IntegrationType.ETO:
        integrationProps = new EtoIntegrationProps(root);
        break;
    case IntegrationType.NONE:
        let backupTenantId: string | null = null;
        if (IntegrationUtils.canFunctionAutonomously()) {
            backupTenantId = DEFAULT_OVERRIDE_TENANT_ID;
        }
        integrationProps = new NoneIntegrationProps(root, backupTenantId);
        break;
    default:
        throw new Error(`Unknown integration type passed in: ${integrationType}`);
}

AnalyticsServiceFactory.init({
    userId: integrationProps.getUserId(),
    apiKey: integrationProps.getPendoAPIKey(),
    username: integrationProps.getUsername(),
    userType: integrationProps.getUserType()
});
